import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/Button';
import { useAuth } from '../hooks/useAuth';

/**
 * Legacy email verification page.
 * Email magic links have been replaced with SMS. This page now redirects to login.
 */
export const VerifyPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // If user is authenticated, redirect to dashboard
    if (user) {
      navigate('/dashboard');
      return;
    }

    // Check if this is an SMS verification link (has token param)
    const token = searchParams.get('token');
    if (token) {
      // Redirect to SMS verify page
      navigate(`/auth/verify-sms?token=${token}`);
    }
  }, [user, navigate, searchParams]);

  return (
    <div className="page-shell mobile-safe-padding mobile-safe-top flex min-h-screen items-center justify-center">
      <div className="enpal-card w-full max-w-md text-center">
        <img src="/enpal-logo.png" alt="Enpal" className="mx-auto mb-6 h-10 w-auto" />
        <h1 className="mb-4 text-3xl font-bold text-enpal-downriver">Link non valido</h1>
        <p className="mb-3 text-base text-enpal-stone-grey">I link di accesso via email sono stati sostituiti con Whatsapp.</p>
        <p className="mb-6 text-sm text-slate-500">Richiedi un nuovo link di accesso dalla pagina di login.</p>
        <Button onClick={() => navigate('/login')} fullWidth>
          Vai al login
        </Button>
      </div>
    </div>
  );
};

